import JsonLd from '@/components/base/JsonLd';
import { seoArticles } from '@/mocks/seoData';

const siteUrl = String(import.meta.env.VITE_SITE_URL || '').replace(/\/+$/, '');
const SITE_NAME = 'Basetao Sheet';
const SITE_DESCRIPTION =
  'The ultimate resource for discovering researched Basetao products, buying guides, shipping cost analysis, reviews, and expert tips.';
const LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png';

export function HomeSchema() {
  const data = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: SITE_NAME,
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: LOGO_URL,
        },
      },
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        name: SITE_NAME,
        url: siteUrl,
        description: SITE_DESCRIPTION,
        publisher: { '@id': `${siteUrl}/#organization` },
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  };

  return <JsonLd data={data} />;
}

export function ArticleSchema({ slug }: { slug: string }) {
  const article = seoArticles.find((item) => item.slug === slug);
  if (!article) {
    return null;
  }

  const publisher = {
    '@type': 'Organization',
    name: SITE_NAME,
    url: siteUrl,
    logo: { '@type': 'ImageObject', url: LOGO_URL },
  };

  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${siteUrl}/${slug}`,
    },
    author: { '@type': 'Organization', name: SITE_NAME, url: siteUrl },
    publisher,
    datePublished: '2026-08-18',
    dateModified: '2026-08-18',
  };

  return <JsonLd data={data} />;
}